import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import {
  selectAllStations,
  selectFilteredAndVisibleStations,
  selectStationById,
} from "../../../store/stationsSlice";

import { MapBoard } from "../../MapBoard";
import { StationDetailsModal } from "../../modals/StationDetailsModal";

const NUMBER_OF_STATIONS_PER_PAGE = 15;

export const Stations = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [syncWithMap, setSyncWithMap] = useState(false);
  const [clickedStationCode, setClickedStationCode] = useState();
  const [stationCodeToShowDetails, setStationCodeToShowDetails] =
    useState(null);
  const stationToShowDetails = useSelector((state) =>
    selectStationById(state, stationCodeToShowDetails)
  );

  const { t } = useTranslation();

  const allStations = useSelector(selectAllStations);
  const visibleStations = useSelector(selectFilteredAndVisibleStations);
  const fetchStatus = useSelector((state) => state.stations.fetchStatus);

  const stations = syncWithMap ? visibleStations : allStations;
  const numOfPages = Math.ceil(stations.length / NUMBER_OF_STATIONS_PER_PAGE);

  if (numOfPages > 0 && currentPage > numOfPages) {
    setCurrentPage(numOfPages);
  }

  const pageNumberButtons = [...Array(numOfPages).keys()].map((key) => {
    let pageNumber = key + 1;
    let className =
      pageNumber === currentPage
        ? "pagenumber active"
        : "pagenumber waves-effect";
    return (
      <li
        key={pageNumber}
        className={className}
        onClick={() => setCurrentPage(pageNumber)}
      >
        <a>{pageNumber}</a>
      </li>
    );
  });
  const pageMoveButtons = (
    <ul className="pagination">
      <li className="pagearrow waves-effect hide-on-med-and-down">
        <a onClick={() => setCurrentPage(1)}>
          <i className="ion ion-ios-arrow-back"></i>
          <i className="ion ion-ios-arrow-back"></i>
        </a>
      </li>
      <li className="pagearrow waves-effect">
        <a
          onClick={() =>
            setCurrentPage(currentPage > 1 ? currentPage - 1 : currentPage)
          }
        >
          <i className="ion ion-ios-arrow-back"></i>
        </a>
      </li>
      {pageNumberButtons}
      <li className="pagearrow waves-effect">
        <a
          onClick={() =>
            setCurrentPage(
              currentPage < numOfPages ? currentPage + 1 : currentPage
            )
          }
        >
          <i className="ion ion-ios-arrow-forward"></i>
        </a>
      </li>
      <li className="pagearrow waves-effect hide-on-med-and-down">
        <a onClick={() => setCurrentPage(numOfPages)}>
          <i className="ion ion-ios-arrow-forward"></i>
          <i className="ion ion-ios-arrow-forward"></i>
        </a>
      </li>
    </ul>
  );

  const firstStationIndex = (currentPage - 1) * NUMBER_OF_STATIONS_PER_PAGE;
  const stationTableItems = stations
    .slice(firstStationIndex, firstStationIndex + NUMBER_OF_STATIONS_PER_PAGE)
    .map((station) => {
      return (
        // <tr key={station.code} onClick={() => setClickedStationCode(station.code)}>
        <tr
          key={station.code}
          onClick={() => showStationDetails({ detail: station.code })}
          style={{ cursor: "pointer" }}
        >
          <td>{station.code}</td>
          <td>{station.name}</td>
          <td
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {station.stationType &&
              t("page.stations.installationType." + station.stationType)}
          </td>
          {/* <td>{station.sensorsInKorean.join(', ')}</td> */}
          <td
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {station.sensors.map((s) => t("sensorType." + s)).join(", ")}
          </td>
          {/* <td>{station.site_class && `${station.site_class.vs30}, ${station.site_class.h_and_vs_soil}`}</td> */}
        </tr>
      );
    });

  const handleChange = (event) => {
    if (event.target && event.target.name === "sync-with-map") {
      setSyncWithMap(event.target.checked);
      // setCurrentPage(1)
    }
  };

  const showStationDetails = (event) => {
    const stationCode = event.detail;
    // console.log('Stations::showStationDetails: stationCode = ', stationCode)
    setStationCodeToShowDetails(stationCode);
  };

  // const closeStationDetails = () => {
  //   setStationCodeToShowDetails('')
  // }

  const downloadStationList = () => {
    let csvLables =
      "code,name,latitude,longitude,installation type,sensors,VS30(by downhole test),VS30(by HVSR estimation),VS30(by P-wave estimation),H&VSSoil(by downhole test)";
    const csvContents = stations
      .map(
        ({
          code,
          name,
          latitude,
          longitude,
          stationType,
          sensorsInKorean,
          site_class,
        }) => {
          const sensors = sensorsInKorean.join("+");
          let content = [
            code,
            name,
            latitude,
            longitude,
            stationType,
            sensors,
          ].join(",");
          if (site_class) {
            if (site_class.vs30) {
              content += site_class.vs30["Downhole test"]
                ? `,${site_class.vs30["Downhole test"]}`
                : ",";
              content += site_class.vs30["HVSR estimation"]
                ? `,${site_class.vs30["HVSR estimation"]}`
                : ",";
              content += site_class.vs30["P-wave estimation"]
                ? `,${site_class.vs30["P-wave estimation"]}`
                : ",";
            } else {
              content += ",,,";
            }
            if (site_class.h_and_vs_soil) {
              content += site_class.h_and_vs_soil["Downhole test"]
                ? `,${site_class.h_and_vs_soil["Downhole test"]}`
                : ",";
            } else {
              content += ",";
            }
          } else {
            content += ",,,,";
          }
          return content;
        }
      )
      .join("\n");
    const csvFile = "\ufeff" + csvLables + "\n" + csvContents;
    const blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "kquake_stations.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      alert(
        "다운로드 기능이 호환되지 않는 브라우저입니다. 다른 브라우저를 이용해주세요."
      );
    }
  };

  useEffect(() => {
    window.addEventListener("showStationDetails", showStationDetails);
  }, []);

  // useEffect(() => {
  //   console.log('Stations::useEffect:currentPage = ', currentPage)
  //   console.log('Stations::useEffect:numOfPages = ', numOfPages)
  //   if (numOfPages > 0 && currentPage > numOfPages) {
  //     setCurrentPage(numOfPages)
  //   }
  // }, [numOfPages])

  return (
    <div className="container">
      <div className="sub-container">
        <div className="row">
          <MapBoard clickedStationFromTable={clickedStationCode} />
          <div className="col l5 m12 s12 p0 hide-on-med-and-down">
            <div className="clearfix">
              <div className="left ">
                <p>
                  <label>
                    <input
                      type="checkbox"
                      name="sync-with-map"
                      className="filled-in"
                      checked={syncWithMap}
                      onChange={handleChange}
                    />
                    <span>{t("page.stations.onlyListStationsShownOnMap")}</span>
                  </label>
                </p>
              </div>
              <div className="right hide-on-med-and-down">
                <button
                  type="button"
                  onClick={downloadStationList}
                  className="waves-light waves-effect button-md"
                >
                  {t("page.stations.downloadList")}
                </button>
              </div>
              <div
                className="clearfix table-fixed-container"
                style={{ minHeight: "700px" }}
              >
                <table className="table-bordered table-title-style-1 table-title-style table-fixed table_sort highlight centered datatable ">
                  <thead>
                    <tr className="sortable">
                      <th className="">{t("w.stationCode")}</th>
                      <th className="">{t("w.stationName")}</th>
                      <th className="">
                        {t("page.stations.installationType.title")}
                      </th>
                      <th className="">{t("page.stations.sensorTypes")}</th>
                      {/* <th className="">지반분류</th> */}
                    </tr>
                  </thead>
                  <tbody>{stationTableItems}</tbody>
                </table>
                {/* <center>
                  {fetchStatus === 'loading' && "관측소 목록을 불러오고 있습니다."}
                  {fetchStatus === 'failed' && "관측소 목록을 불러오데 실패하였습니다."}
                </center> */}
              </div>
              <div className="pagenum">{pageMoveButtons}</div>
            </div>
          </div>
        </div>
      </div>
      <StationDetailsModal
        station={stationToShowDetails}
        onClose={() => setStationCodeToShowDetails("")}
      />
    </div>
  );
};
